import { Box, Button, Flex, Stack, Textarea, Text } from "@mantine/core"
import { useContext, useState } from "react";
import DiscoveryContext from "./DiscoveryContext";
import { IconCheck, IconX } from "@tabler/icons";
import SyncContext from "../../context/SyncContext";
import BagelAccordionMenu from "../general/BagelAccordionMenu";
import { OverflownText } from "../OverflownText";


const NewIdeaForm = ({ setNewIdeaFormView }: { setNewIdeaFormView: React.Dispatch<React.SetStateAction<boolean>>; }) => {

  const { description, setDescription, convertFromDiscoveryToIdea, ideaId } = useContext(DiscoveryContext);

  const {
    components,
    domains,
    displayState,
  } = useContext(SyncContext);

  const [domain, setDomain] = useState("Unassigned");
  const [mandatoryDomain, setMandatoryDomain] = useState(false);
  const [productArea, setProductArea] = useState("Unassigned");
  const [component, setComponent] = useState<any>();
  const [productAreaMandatory, setProductAreaMandatory] =
    useState<boolean>(false);
  const [componentsByDomain, setComponentsByDomain] =
    useState<any[]>(components || []);
  const [title, setTitle] = useState<any>('');
  const filterComponentByDomain = (domainValue: string) => {
    const copy = [...components];
    const arr: any[] = copy.filter((s: any) => s.domain === domainValue) || [];
    setComponentsByDomain(arr);
    const names = arr.map((a: any) => a.name);
    if (!names.includes(productArea)) {
      setProductArea("Unassigned");
    }
  };
  const [selectedComponent, setSelectedComponent] = useState("");

  const switchToIdea = () => {
    const obj = {
      id: ideaId,
      title: title,
      description: description,
      componentId: component?._id,
      state: 'active'
    }

    convertFromDiscoveryToIdea(obj)
  }

  const domainComponentMap = domains.map((domain: any) => {
    const childComponents = components
      .filter((comp: any) => comp.domain?.toLowerCase()?.trim() === domain.name?.toLowerCase()?.trim())
      .map((comp: any) => ({
        ...comp,
        id: comp._id,
        childComponents: comp.childComponents || []
      }));

    return {
      ...domain,
      id: domain._id,
      name: domain.name,
      ownerName: domain.ownerName,
      productComponents: childComponents
    };
  });
  return (
    <Stack
      h={`calc(150vh - 115px)`}
      sx={{ borderRight: "1px solid #D8D8DB" }}
      justify="space-between"
    >

      {/* Title */}

      <Box py={24}
        px={36}>


        <Box mb={24}>
          <Flex mb={8}>
            <Text fz={14} fw={600} color="#212529" >Title </Text>
            {title.length < 3 && <Text ml={3} fz={12} color="red">*</Text>}
          </Flex>


          <Textarea
            sx={{ borderRadius: 8 }}
            minRows={1}
            mb={16}
            value={title}
            onChange={(event) => setTitle(event.currentTarget.value)}
          />
          <Flex
            my='lg'
            h={12}
            w='100%'
            px='xs'


            justify='flex-end'
            align='center'
          >


            <Flex
              align='center'
              ml='md'
              sx={{
                cursor: 'pointer'
              }}
              onClick={() => setTitle('')}
            >
              <Box mr='3px' /* mt='2px' */>
                <IconX size={12} color='#5C5CEB' />
              </Box>

              <Text fz="12px" color='#5C5CEB'> Clear</Text>
            </Flex>


          </Flex>
        </Box>

        {/* Description */}

        <Box mb={24}>
          <Flex mb={8}>
            <Text fz={14} fw={600} color="#212529">Description </Text>
            {description.length < 3 && <Text ml={3} fz={12} color="red">*</Text>}
          </Flex>


          <Textarea
            sx={{ borderRadius: 8 }}
            minRows={5}
            mb={16}
            value={description}
            onChange={(event) => setDescription(event.currentTarget.value)}
            onBlur={(event) => {
              console.log(event.currentTarget.value);

            }}
          />
          <Flex
            my='lg'
            h={12}
            w='100%'
            px='xs'


            justify='flex-end'
            align='center'
          >


            <Flex
              align='center'
              ml='md'
              sx={{
                cursor: 'pointer'
              }}
              onClick={() => setDescription('')}
            >
              <Box mr='3px' mt='2px'>
                <IconX size={12} color='#5C5CEB' />
              </Box>

              <Text fz="12px" color='#5C5CEB'> Clear</Text>
            </Flex>


          </Flex>
        </Box>
        <Box>

          {/* Product area  */}
          <Box>

            <Flex mb={8}>
              <Text fz={14} fw={600} color="#212529">Product area </Text>
              {productArea === 'Unassigned' && <Text ml={3} fz={12} color="red">*</Text>}
            </Flex>
            <BagelAccordionMenu
              selectedComponent={selectedComponent}
              isAiSuggestion={false}
              // loading={loading}
              onSelect={(item: any, type: string) => {
                if (type === 'Domain') {
                  setDomain(item.name);
                  // filterComponentByDomain(item.name);
                } else {
                  setProductArea(item.name);
                  setComponent(item)
                  setProductAreaMandatory(true);
                  setSelectedComponent(item);

                }
              }}
            >
              <Flex
                h="32px"
                px="sm"
                bg="#F8F9FB"
                align="center"
                sx={{
                  cursor: "pointer",
                  borderRadius: "5px",
                  transition: "background-color 0.2s",
                  "&:hover": {
                    backgroundColor: "#EDEFF3", // slightly darker on hover
                  },
                }}
              >
                <OverflownText lineClamp={1}>{productArea && productArea !== "Unassigned" && <Text span color='dimmed'>.../ </Text>}{productArea}</OverflownText>
              </Flex>
            </BagelAccordionMenu>
          </Box>
        </Box>
      </Box>
      <Stack
        justify="center"
        h={64}
        sx={{
          borderTop: "1px solid #D8D8DB",
          position: "sticky",
          bottom: 0,
          backgroundColor: "white",
          zIndex: 10,
        }}
        px={36}
      >

        <Flex justify='space-between'>
          <Button
            /* disabled={description.length < 3} */
            w={104}
            color="dark"
            variant="outline"
            leftIcon={<IconX size={14} color="#212529" />}
            onClick={() => { setNewIdeaFormView(false) }}
          >
            <Text color="#212529" fz={12}>
              Cancel
            </Text>

          </Button>
          <Button
            w={104}
            disabled={description.length < 3 || title.length < 3 || !component}
            styles={(theme) => ({
              root: {
                height: "32px",
                backgroundColor: "#5C5CEB",
                border: 0,
                fontWeight: 400,
                padding: 0,
                "&:hover": {
                  backgroundColor: theme.fn.darken("#5C5CEB", 0.05),
                },
              },
            })}
            leftIcon={<Box mr={1}>
              <IconCheck size={14} />
            </Box>}
            onClick={switchToIdea}
          >
            <Text fz={12}>
              Create
            </Text>

          </Button>
        </Flex>
      </Stack>
    </Stack>
  )
}

export default NewIdeaForm